import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import Field, { hasDataInFields } from '../../Field';
import BlockContainer from '../BlockContainer';

import css from './BlockRecommendedListing.module.css';
import { LandingListingCard } from '../../../../components';

import { updateFavorites } from '../../../../ducks/favorites.duck';
import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../../../util/routes';

const FieldMedia = props => {
  const { className, media, sizes, options } = props;
  const hasMediaField = hasDataInFields([media], options);
  return hasMediaField ? (
    <div className={classNames(className, css.media)}>
      <Field data={media} sizes={sizes} options={options} />
    </div>
  ) : null;
};

/**
 * @typedef {Object} FieldComponentConfig
 * @property {ReactNode} component
 * @property {Function} pickValidProps
 */

/**
 * This returns a component that can render 'defaultBlock' config.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.blockId id from the block config
 * @param {string} props.blockName name from the block config (not used)
 * @param {'defaultBlock'} props.blockType blockType is set to 'defaultBlock'
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {string?} props.className add more styles in addition to components own css.root
 * @param {string?} props.mediaClassName add styles for the block's attached media field
 * @param {string?} props.textClassName add styles for the block's attached text field
 * @param {string?} props.ctaButtonClass add styles for the block's attached CTA field
 * @param {Object?} props.title heading config for the block
 * @param {Object?} props.text content config for the block (can be markdown)
 * @param {Object?} props.callToAction call to action button (e.g. internal link config)
 * @param {string?} props.responsiveImageSizes
 * @param {Object} props.options extra options for the block component (e.g. custom fieldComponents)
 * @param {Object<string,FieldComponentConfig>?} props.options.fieldComponents Custom fieldComponents
 * @returns {JSX.Element} component that renders block type: 'defaultBlock'
 */
const BlockRecommendedListing = props => {
  const {
    blockId,
    className,
    rootClassName,
    mediaClassName,
    textClassName,
    ctaButtonClass,
    title,
    text,
    callToAction,
    media,
    responsiveImageSizes,
    options,
    alignment,
    currentUser,
    onToggleFavorite,
    content,
  } = props;

  // CUSTOM
  const history = useHistory();
  const location = useLocation();
  const routeConfiguration = useRouteConfiguration();

  const classes = classNames(rootClassName || css.root, className, css.categoryImg);
  const hasTextComponentFields = hasDataInFields([title, text, callToAction], options);

  const alignmentClasses = {
    left: css.alignLeft,
    center: css.alignCenter,
    right: css.alignRight,
  };

  const alignmentClass = alignmentClasses[alignment];

  // CUSTOM
  const handleRequireLogin = () => {
    const state = {
      from: `${location.pathname}${location.search}${location.hash}`,
    };

    history.push(
      createResourceLocatorString(
        'LoginPage',
        routeConfiguration,
        {},
        {}
      ),
      state
    );
  };

  return (
    <BlockContainer id={blockId} className={classNames(classes, alignmentClass)}>
      <LandingListingCard listing={content} currentUser={currentUser} onToggleFavorite={onToggleFavorite} onRequireLogin={handleRequireLogin}/>
    </BlockContainer>
  );
};

// export default BlockRecommendedListing;
// CUSTOM
const mapStateToProps = state => {
  const { currentUser } = state.user;

  return {
    currentUser,
  };
};

const mapDispatchToProps = dispatch => ({
  onToggleFavorite: listingId => {
    return dispatch((innerDispatch, getState) => {
      const { user } = getState();

      return innerDispatch(
        updateFavorites(listingId, user.currentUser)
      );
    });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BlockRecommendedListing);
